import {
    FETCH_COUNTRIES_SUCCESS_ACTION,
  
} from './action'

const initialState = {
    processing: false,
    error: false,
}

export default function (state: any = initialState, action: Function) {

    switch (action.type) {
        case FETCH_COUNTRIES_SUCCESS_ACTION:

            return {
                ...state,
                CountryList: action.payload.rows,
                CountryCount: action.payload.count
            }

        default:
            return {
                ...state
            }
    }

}